<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 sm12 md12 lg5 xl5 class="pa-5 mr-5">
            <h2>Geslo za prijavo</h2>
            <empty-space />
            <change-password />
        </v-flex>
        <v-flex v-if="!is_tus_team_only" xs12 sm12 md12 lg5 xl5 class="pa-5 mr-5">
            <h2>Prijavljene seje</h2>
            <empty-space />
            <active-login-sessions />
        </v-flex>
        <v-flex v-if="!is_tus_team_only && !connected_account_is_temp"  xs12 sm12 md12 lg5 xl5 class="pa-5 mr-5">
            <h2>Odstranitev kartice</h2>
            <empty-space />
            <disconnect-card></disconnect-card>
        </v-flex>
        <v-flex v-if="!is_tus_team_only"  xs12 sm12 md12 lg5 xl5 class="pa-5 mr-5">&nbsp;</v-flex>
    </v-layout>
</template>

<script>
    import ChangePassword from "./embeded-views/ChangePassword"
    import ActiveLoginSessions from "./embeded-views/ActiveLoginSessions"
    import DisconnectCard from "./embeded-views/DisconnectCard";
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";

    export default {
        name: "SecurityTab",
        components: {EmptySpace, ChangePassword, ActiveLoginSessions, DisconnectCard},
        computed: {
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            card_number: utils.vuexBuildSetGet(this, 'profile', 'user.card'),
            name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
            lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.email'),
            mobileNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.mobileNo'),
            is_tus_team_only: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team_only'),
        }
    }
</script>

<style scoped>
    @import "../../styles/variables.less";

    .foreword {
        font-style: italic;
    }

    .user-info p{
        padding: 5px;
        margin-bottom: 0px;
        font-weight: bold;
        border-top: 1px solid #c1c1c1;
    }

    .user-info p:last-child{
        border-bottom: 1px solid #c1c1c1;
    }
    .user-info label{
        font-weight: normal;
        width: 250px;
        display: inline-block;
    }

</style>